import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Card } from 'antd';
import styled from 'styled-components';

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 24px;
  direction: rtl; /* Hebrew text alignment */
  @media screen and (max-width: 768px) {
    padding: 8px 0;
  }
`;

export const CardContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 0;
  padding-block-end: 24px;
  border-bottom: 1px solid #dfe2e6;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }
`;

export const CardWrapper = styled(Card)`
  border: none;
  border-radius: 8px;
  overflow: hidden;

  .ant-card-body {
    padding: 0 32px !important;
  }

  &:last-child ${CardContent} {
    border-bottom: none;
  }

  @media screen and (max-width: 768px) {
    .ant-card-body {
      padding: 0 !important;
    }
  }
`;

export const CardImageWrapper = styled.div`
  flex-shrink: 0;
  min-width: 64px;

  img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const UserName = styled.span`
  font-size: 18px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.extremeBold};
`;

export const FeedbackText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};
  margin: 0;
`;

export const FeedbackTextQuote = styled.q`
  quotes: '”' '“' '’' '‘';
  &::before,
  &::after {
    font-size: 2em;
    vertical-align: -0.2em;
  }
`;
